module.exports = __webpack_public_path__ + "static/media/cy.9296b2fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cy.svg
// module id = 96
// module chunks = 0